import { create } from "zustand";
import { persist } from "zustand/middleware";

interface Customer {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  streetName: string;
  streetNumber: string;
  zipCode: string;
  city: string;
}

interface CustomerStore {
  customer: Customer;
  setCustomer: (customer: Customer) => void;
  updateCustomer: (customer: Customer) => void;
}

export const useCustomerStore = create<CustomerStore>()(
  persist(
    (set) => ({
      customer: {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        streetName: "",
        streetNumber: "",
        zipCode: "",
        city: "",
      },
      setCustomer: (customer) =>
        set(() => ({
          customer,
        })),
      updateCustomer: (customer) =>
        set((state) => ({
          customer: { ...state.customer, ...customer },
        })),
    }),
    {
      name: "customer-storage", // unique name for localStorage key
    }
  )
);
